import React, { useState, useEffect, useRef } from 'react';

const GameScreen = ({ onGameEnd }) => {
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30); // 30 seconds game
  const [particles, setParticles] = useState([]);
  const timerRef = useRef(null);
  const scoreRef = useRef(0); // Use ref to track score without causing re-renders
  const startTimeRef = useRef(Date.now()); // Track when game started

  useEffect(() => {
    // Record start time
    startTimeRef.current = Date.now();

    // Start the timer
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          const duration = Date.now() - startTimeRef.current;
          onGameEnd(scoreRef.current, duration); // Pass both score and duration
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [onGameEnd]);

  const handleTouch = (e) => {
    // Prevent default to avoid double firing on some devices
    // e.preventDefault(); 

    scoreRef.current += 1;
    setScore(scoreRef.current);

    // Get coordinates
    let x, y;
    if (e.type === 'touchstart') {
      x = e.touches[0].clientX;
      y = e.touches[0].clientY;
    } else {
      x = e.clientX;
      y = e.clientY;
    }

    // Add particle
    const id = Date.now();
    setParticles(prev => [...prev, { id, x, y }]);

    // Remove particle after animation
    setTimeout(() => {
      setParticles(prev => prev.filter(p => p.id !== id));
    }, 1000);
  };

  const handleEndGame = () => {
    clearInterval(timerRef.current);
    const duration = Date.now() - startTimeRef.current;
    onGameEnd(scoreRef.current, duration);
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <div className="timer-display {timeLeft <= 5 ? 'urgent' : ''}">
          ⏳ {timeLeft}s
        </div>
        <div className="score-display">
          {score}
        </div>
      </div>

      <div
        className="touch-area"
        onClick={handleTouch}
        onTouchStart={handleTouch}
      >
        {score === 0 ? 'BAŞLA!' : '👆'}
      </div>

      {/* Particles */}
      {particles.map(p => (
        <div
          key={p.id}
          style={{
            position: 'fixed',
            left: p.x,
            top: p.y,
            pointerEvents: 'none',
            color: '#0aff0a',
            fontSize: '2rem',
            fontWeight: 'bold',
            animation: 'float-up 1s ease-out forwards',
            zIndex: 100
          }}
        >
          +1
        </div>
      ))}

      <style>{`
        @keyframes float-up {
          0% { transform: translateY(0) scale(1); opacity: 1; }
          100% { transform: translateY(-100px) scale(1.5); opacity: 0; }
        }
      `}</style>

      <button className="neon-btn secondary" onClick={handleEndGame} style={{ marginTop: '50px' }}>
        ⏹️ Oyunu Bitir
      </button>
    </div>
  );
};

export default GameScreen;